import { beautify } from './number';

export function getLandAreaLabel(min: number | undefined, max: number | undefined): string | null {
  if (min && !max) {
    return `от ${beautify(min)} сот.`;
  } else if (!min && max) {
    return `до ${beautify(max)} сот.`;
  } else if (min && max) {
    return `${beautify(min)} - ${beautify(max)} сот.`;
  }

  return null;
}
